// a function takes 3 dates as arguments
// if first date lies between 2nd and third date it return true
// dateFrom and dateTill are date objects not string.
// but date ie first parameter will be string bcoz its taken form storage.
export default function dateMatcher(date, dateFrom, dateTill) {
  /* if dateTill has only Date component and not time then Date.parse() will be smaller value since 
  in that case 7th nov 12 am is considered and feedback taken on 7th nov 1pm will be left out since it 
  will have bigger date.parse value.. hence DateTill should be d.toString()

 similaryl. dateFrom, should have only date component so that all feedback on that day are 
 filtered in . if dateFrom has time component as well and we are checking say at 1 pm for last 7 days
 and date from is 1st nov 1pm will exclude all feedback taken on 1st nov before 1pm as their 
 date.parse() value will be smaller than dateFrom. hence DateFrom should be d.toDateString()

  
  */
  var dateCheck = new Date(date);

  let dateCheck1 = Date.parse(dateCheck);
  let dateFrom1 = Date.parse(dateFrom);
  let dateTill1 = Date.parse(dateTill);

  // console.log(dateTill);

  //   var from = Date.parse(dateFrom);
  // var to   = Date.parse(dateTo);
  // var check = Date.parse(dateCheck );
  // console.log(`${dFrom}  ${dateCheck} fd ${dateTo}`);
  // console.log(Date.parse(dateFrom));

  if (dateCheck1 <= dateTill1 && dateCheck1 >= dateFrom1) {
    return true;
  } else return false;
}
